import React, { useEffect, useState } from "react";
import "./Services.css";
import { motion } from "framer-motion";
import PageOverView from "../../components/Page Overview/index.js";
import Breadcrumb from "../../components/BreadCrumb/index.js";


const features = [
    {
        title: "Increased Website Traffic",
        description: "Drive organic traffic by ranking higher on search engine result pages (SERPs).",
        imgUrl: "./img/services/seo-optimization/increased-website-traffic.png",
    },
    {
        title: "Better User Experience",
        description: "Improve site navigation and performance to keep users engaged.",
        imgUrl: "./img/services/seo-optimization/better-user-experience.jpg",
    },
    {
        title: "Higher ROI",
        description: "Achieve better returns on your investment with cost-effective SEO strategies.",
        imgUrl: "./img/services/seo-optimization/higher-roi.png",
    },
    {
        title: "Increased Brand Credibility",
        description: "Boost brand trust by appearing at the top of search results.",
        imgUrl: "./img/services/seo-optimization/increased-brand-credibility.png",
    },
    {
        title: "Competitive Advantage",
        description: "Outperform competitors by staying ahead in search engine rankings.",
        imgUrl: "./img/services/seo-optimization/competitive-advantage.png",
    },
    {
        title: "Targeted Audience Reach",
        description: "Connect with the right audience by optimizing for relevant keywords.",
        imgUrl: "./img/services/seo-optimization/targeted-audience-reach.jpg",
    },
];



const SEOOptimization = () => {
    const [, setScrollY] = useState(0);
    const paths = [
        { name: "Home", link: "/" },
        { name: "Services", link: "" },
        { name: "SEO Optimization", link: "" },
    ];

    const handleScroll = () => {
        setScrollY(window.scrollY);
    };

    useEffect(() => {
        window.scrollTo(0, 0);
        window.addEventListener("scroll", handleScroll);
        return () => window.removeEventListener("scroll", handleScroll);
    }, []);

    return (
        <>
            <div className="page-overview">
                <PageOverView text="SEO Optimization" description="Unlock the power of search engines to boost your online presence and drive measurable results." />
            </div>
            <motion.div
                key="div0"
                initial={{ opacity: 0, x: 100 }}
                animate={{ opacity: 1, x: 0 }}
                exit={{ opacity: 0, x: 100 }}
                transition={{ duration: 0.7 }}>
                <div className="service-page">
                    <div className="uiux-page">
                        <section className="about">
                            <h2>What is SEO?</h2>
                            <p>
                                SEO (Search Engine Optimization) is the process of improving your website's visibility on search engines like Google, Bing, and Yahoo. It involves optimizing content, structure, and technical elements to rank higher and attract more organic traffic.
                            </p>
                            <img
                                src="./img/services/seo-optimization.jpg"
                                alt="SEO Optimization"
                                className="about-image"
                            />
                        </section>
                        <section className="services">
                            <h2>Our Key Services</h2>
                            <div className="services-grid">
                                {features.map((feature, index) => (
                                    <div className="service-card" key={index}>
                                        <img
                                            src={feature.imgUrl}
                                            alt={feature.title}
                                            className="service-img"
                                        />
                                        <h3>{feature.title}</h3>
                                        <p>{feature.description}</p>
                                    </div>
                                ))}
                            </div>
                        </section>
                        <section className="benefits">
                            <h2>Key SEO Strategies</h2>
                            <ul>
                                <li>Keyword Research: Identify and target high-performing keywords.</li>
                                <li>On-Page Optimization: Improve content, meta tags, and headers for search engines.</li>
                                <li>Technical SEO: Enhance website speed, mobile-friendliness, and security.</li>
                                <li>Link Building: Gain backlinks from reputable sources to increase authority.</li>
                                <li>Content Marketing: Publish high-quality, relevant content consistently.</li>
                                <li>Analytics and Reporting: Measure success and adjust strategies for better results.</li>
                            </ul>
                        </section>
                        <footer className="contact">
                            <h2>Ready to Boost Your SEO?</h2>
                            <p>
                                Take your website to the next level with professional SEO services. <br />
                                Contact us at{" "}
                                <a href="mailto:info@betajapansoftware">info@betajapansoftware</a>
                            </p>
                        </footer>
                    </div>
                </div>
            </motion.div>
            <div className="breadcrumb-container">
                <Breadcrumb paths={paths} />
            </div>
        </>
    );
};

export default SEOOptimization;
